export declare type SortDirection = "" | "asc" | "desc";
export declare interface SortData {
    sortProperty: string;
    direction: SortDirection;
}
